import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from '../../components/index';

const ModalAlertaNumeroNegativo = (props) => {
  const montaAlerta = alerta => (
    <div className="row">
      {alerta.descricao}
    </div>
  );

  const montaListaAlertas = () => {
    const listaRelacoes = [];
    props.alertas.forEach((alerta) => {
      listaRelacoes
        .push(montaAlerta(alerta));
    });
    return listaRelacoes;
  };

  const montaModalContent = () => (
    <React.Fragment>
      {montaListaAlertas()}
    </React.Fragment>
  );

  const modalFooter = (
    <React.Fragment>
      <div className="right">
        <Button
          title="Fechar"
          onClick={props.handleModal}
          hint="Fechar"
        />
      </div>
    </React.Fragment>
  );

  return (
    <Modal
      {...props}
      alert
      alertType="warning"
      conteudomodal={montaModalContent()}
      conteudofooter={modalFooter}
      onHide={props.handleModal}
      showTitle
      size="sm"
      title=""
      showModal
    />
  );
};

ModalAlertaNumeroNegativo.propTypes = {
  handleModal: PropTypes.func.isRequired,
  aceitar: PropTypes.func.isRequired,
  alertas: PropTypes.arrayOf({ descricao: PropTypes.string }).isRequired,
};

export default ModalAlertaNumeroNegativo;



// WEBPACK FOOTER //
// ./src/pages/calculador-amd/ModalAlertaNumeroNegativo.jsx